import { HandCoins } from "lucide-react";
export default function ComplianceAndAccuracyHeader() {
  return <section data-section-id="261782" id="why-choose-us" className="bg-background text-foreground py-16 md:py-24 px-6">
      <div className="container mx-auto max-w-4xl flex flex-col items-center text-center gap-6">
        <div className="bg-secondary p-4 rounded-lg shadow-md">
          <HandCoins className="w-16 h-16 text-secondary-foreground mb-2" strokeWidth={1.5} aria-hidden="true" />
        </div>
        
        <h3 className="text-3xl md:text-4xl font-bold font-default tracking-tight text-foreground">
          Expert Local Team
        </h3>
        
        <p className="text-lg md:text-xl leading-relaxed text-muted-foreground max-w-3xl font-sans"><strong className="font-semibold text-primary" data-ast-id="f:/src/pages/Services/sections/ComplianceAndAccuracyHeader.tsx|sig:jf1syw" data-ast-start="773" data-ast-end="983">Property Value Enhancement</strong> Our experienced team, top-quality equipment, and attention to excellence ensures a fast &amp; efficient, eco-friendly process. We take pride in delivering professional mulching services that transform your landscape while preserving the local ecosystem.</p>
      </div>
    </section>;
}